export default __webpack_public_path__ + "static/media/top10-badge.77b17073.svg";